import { render, staticRenderFns } from "./cyapss-footer.component.vue?vue&type=template&id=64f01fd4"
import script from "./cyapss-footer.component.ts?vue&type=script&lang=ts&external"
export * from "./cyapss-footer.component.ts?vue&type=script&lang=ts&external"
import style0 from "./cyapss-footer.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports